import MainLayout from '../layouts/main';
import ReportsListContainer from './container';

function ReportsPage() {
  return (
    <MainLayout>
      <ReportsListContainer/>
    </MainLayout>
  );
}

export default ReportsPage;
